import {
  LOAD_USER_PAYMENT_METHODS,
  LOAD_USER_PAYMENT_METHODS_FAIL,
  LOAD_USER_PAYMENT_METHODS_SUCCESS,
  LoadUserPaymentMethodsSuccess,
  UserPaymentMethodsAction
} from "../actions";

export interface IUserPaymentMethodsDataState {
  userPaymentMethodsData: any;
  loading: boolean;
  loaded: boolean;
}

export interface IUserPaymentMethodsState {
  userPaymentMethodsData: IUserPaymentMethodsDataState;
}

export const initialState: IUserPaymentMethodsState = {
  userPaymentMethodsData: {
    userPaymentMethodsData: null,
    loading: false,
    loaded: false
  }
};

export function reducer(state: IUserPaymentMethodsState = initialState, action: UserPaymentMethodsAction): IUserPaymentMethodsState {
  let payload: any;

  switch (action.type) {
    case LOAD_USER_PAYMENT_METHODS:
      return {
        ...state,
        userPaymentMethodsData: {
          ...state.userPaymentMethodsData,
          loading: true,
          loaded: false
        }
      };

    case LOAD_USER_PAYMENT_METHODS_SUCCESS:
      payload = (<LoadUserPaymentMethodsSuccess>action).payload;

      return {
        ...state,
        userPaymentMethodsData: {
          ...state.userPaymentMethodsData,
          userPaymentMethodsData: payload,
          loading: false,
          loaded: true
        }
      };

    case LOAD_USER_PAYMENT_METHODS_FAIL:
      return {
        ...state,
        userPaymentMethodsData: {
          ...state.userPaymentMethodsData,
          userPaymentMethodsData: null,
          loading: false,
          loaded: true
        }
      };
  }

  return state;
}
